const validVisibilityTypesList = ['all', 'new', 'none'] as const

export const checkIsVisibilityTypeAllOrNew = (visibilityType: string | null | undefined): boolean =>
  validVisibilityTypesList.some((value) => value === visibilityType)

export const checkInvalidCombination = (visibilityTypes: Array<string | null | undefined>): boolean => {
  const hasEstablishedOnly = visibilityTypes.includes('established')
  const hasNoPatients = visibilityTypes.includes('none')
  const hasAllOrNew = visibilityTypes.includes('all') || visibilityTypes.includes('new')

  return hasEstablishedOnly && hasNoPatients && !hasAllOrNew
}
